import DashboardSideBar from "./navBar";
import DashboardFooter from "./footer";

const DashboardLayout = () => {
    return (
        <>
            <DashboardSideBar />

            <DashboardFooter />
        </>
    )
};

export default DashboardLayout;